import React from "react";

const ProcedureDetails = ({ procedure, onClose }) => {
  if (!procedure) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded shadow-lg w-2/3">
        <h2 className="text-xl font-bold mb-4">Procedure Details</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <strong>Procedure Code:</strong> {procedure.procedureCode}
          </div>
          <div>
            <strong>Procedure Name:</strong> {procedure.procedureName}
          </div>
          <div>
            <strong>Department:</strong> {procedure.departmentID}
          </div>
          <div>
            <strong>Base Cost:</strong> ₹{procedure.baseCost}
          </div>
        </div>

        <div className="my-4">
          <strong>Additional Costs:</strong>
          <ul className="list-disc ml-6">
            {procedure.additionalCosts.map((cost, index) => (
              <li key={index}>{cost}</li>
            ))}
          </ul>
        </div>

        <div className="my-4">
          <strong>Pre-Procedure Checklist:</strong>
          <ul className="list-disc ml-6">
            {procedure.preProcedureChecklist.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="my-4">
          <strong>Post-Procedure Care:</strong>
          <ul className="list-disc ml-6">
            {procedure.postProcedureCare.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="my-4">
          <strong>Required Resources:</strong>
          <ul className="list-disc ml-6">
            {procedure.requiredResources.map((resource, index) => (
              <li key={index}>{resource}</li>
            ))}
          </ul>
        </div>

        <div className="my-4">
          <strong>Insurance Mapping:</strong>
          <ul className="list-disc ml-6">
            {procedure.insuranceMapping.map((insurance, index) => (
              <li key={index}>{insurance}</li>
            ))}
          </ul>
        </div>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProcedureDetails;
